<app-search [options]="equipmentCategories()"
            [required]="true" [formControl]="category" [placeholder]="'Type to search'">
  <div class="invalid-feedback">Equipment type and size are required</div>
</app-search>
